import React, { SVGProps } from "react";
import Icon from "./Icon/Icon";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgIcon = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M6.7 15V7.3l-6.1-6C.4 1 .6.5 1 .5h14c.4 0 .6.5.4.8l-5.7 6v6l-2.2 2.2c-.2.2-.8-.1-.8-.5M2 1.5l5.7 5.4v6.9l1-1V6.9L14 1.5z" />
  </svg>
);
const SvgFunnel = (
  props: Omit<React.ComponentProps<typeof Icon>, "SvgIcon" | "name">
) => <Icon SvgIcon={SvgIcon} name="funnel" {...props} />;
export default SvgFunnel;
